import Form from './form';
import Header from './header';
import {
  INotificationService,
  IPromotionApi,
  NotificationService,
  PromotionApi,
} from '../services';
import Overlay from '../ui/overlay';
import classNames from 'classnames';
import { IVoucherApi, VoucherApi } from '../services/voucherApi';
import { IVoucherTemplateDto } from '../model';
import { useCallback, useState } from 'react';
import { StyledDialog } from '../ui';
import { useTranslation } from 'react-i18next';

const notificationService: INotificationService = new NotificationService();
const voucherApiService: IVoucherApi = new VoucherApi();
const promotionApiService: IPromotionApi = new PromotionApi();

export function Voucher() {
  const { t } = useTranslation();

  const [pdfUrl, setPdfUrl] = useState<string>();

  const onDraft = useCallback(
    async (data: Partial<IVoucherTemplateDto>) => {
      const responseBlob = await voucherApiService.renderDraftVoucher({
        contactLanguage: 'de',
        value: 100.0,
        text: '',
        title: '',
        ...data,
      });

      const pdfUrl = URL.createObjectURL(responseBlob);
      setPdfUrl(pdfUrl);
    },
    [voucherApiService]
  );

  return (
    <div>
      <Overlay service={notificationService}></Overlay>

      <Header></Header>

      <StyledDialog
        onClose={() => setPdfUrl(undefined)}
        isOpen={pdfUrl !== undefined}
        className="h-full pb-0"
      >
        <div className="h-full">
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              width="100%"
              height="100%"
              style={{ border: 'none', minHeight: '500px' }}
              title="PDF Viewer"
            ></iframe>
          )}
        </div>
      </StyledDialog>

      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div
          id="teaser"
          className="m-3 mb-10 space-y-3 text-brand-cashmere-900"
        >
          <h1 className="text-3xl font-serif text-center">
            {t('voucher.header.title')}
          </h1>
          <h1 className="text-lg font-serif text-center">
            {t('voucher.header.subtitle')}
          </h1>

          <p className="mt-2 text-center font-light max-w-lg mx-auto px-4">
            <span>{t('voucher.header.description')}</span>
            <span className="mt-1">{t('voucher.header.signature')}</span>
          </p>
        </div>

        <Form
          voucherApi={voucherApiService}
          promotionApi={promotionApiService}
          notificationService={notificationService}
          onDraftClick={onDraft}
        ></Form>
      </main>
    </div>
  );
}

export default Voucher;
